import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Homepage from '../Pages/HomePage/HomePage';
import ContactUs from '../Pages/ContactUs/Contact';
import LevelPage from '../Pages/Levels/LevelsPage';


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Homepage/>} />
      <Route path="/contact" element={<ContactUs/>}/>
      <Route path="/levels" element={<LevelPage/>}/>
    </Routes>
  );
};

export default AppRoutes;
